import { CREW_ON_BOARD_DATE_PATTERN, CREW_ON_BOARD_MISSING_VALUE } from "../models/crew-on-board.constants";

export function formatCrewOnBoardDate(value: string | null): string {
  if (!value) return CREW_ON_BOARD_MISSING_VALUE;

  const dateParts = CREW_ON_BOARD_DATE_PATTERN.exec(value);
  if (!dateParts) return CREW_ON_BOARD_MISSING_VALUE;

  const [, year, month, day] = dateParts;
  return `${month}/${day}/${year}`;
}

export function formatCrewOnBoardMonths(value: number | null): string {
  return value === null ? CREW_ON_BOARD_MISSING_VALUE : value.toFixed(1);
}
